
export default {
    book: "Резервирай {product}",
    age_limit: "Само за лица над {age} години",
    change_plan: "Промяна на плана",
    upgrade_product: "Подобри продукта",
    choose_product: "Избери {product}",
    days: "{count} ден | {count} дни | {count} дена",
    login_register: "Вход/Регистрация",
    current: "Текущ",
    keyless_benefits: {
        label: 'Директно до автомобила {0}',
        highlight: 'rental service™',
        list: {
            cant_lose_the_key: 'Пълно застраховане',
            zero_excess: 'Нулева франшиза',
            phone_as_a_key: 'Телефон като ключ',
            straight_to_car: 'Без чакане',
            no_queues: 'Без опашки',
            online_id_check: 'Онлайн проверка на самоличността',
            self_checkout: 'Самообслужване',
        },
    },
}